import React from 'react'
import { ComingSoon } from '../../../components/ComingSoon';

export const SMSSent = () => {
  return (
    <ComingSoon heading="SMS Sent">
      <div className="text-sm text-gray-500 font-medium mt-4">🚧 Coming Soon Feature</div>
    </ComingSoon>
  );
}
